import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { isArray } from '@grandvisionhq/utils';
import { useReplaceLineItemContactLensesBundleBenelux } from '../../../hooks/use-replace-line-item-contact-lenses-bundle-benelux.js';
import { Loader } from '../components/Loader.js';
import { SolutionPicker } from '../layouts/SolutionPicker.js';
import { useFetchBundleSolutions } from '../utils/use-fetch-bundle-solutions.js';

const ContactLensesBundleBeneluxSolutionsContainer = ({ subscriptionProductSku  })=>{
    const [bundleSku, setBundleSku] = React.useState(subscriptionProductSku);
    const [isFetching, solutions] = useFetchBundleSolutions(subscriptionProductSku);
    const activeSolution = React.useMemo(()=>{
        return solutions === null || solutions === void 0 ? void 0 : solutions.find((solution)=>solution.bundleSku === bundleSku
        );
    }, [
        bundleSku,
        solutions
    ]);
    const [replaceLineItem, { loading  }] = useReplaceLineItemContactLensesBundleBenelux();
    const handleClick = React.useCallback((ev)=>{
        const newSku = ev.currentTarget.value;
        const existingSku = bundleSku;
        const draft = {
            newSku,
            existingSku
        };
        const onSuccess = ()=>{
            setBundleSku(newSku);
            toast.info('cart.notification.updatedCart');
        };
        const handleError = (message)=>{
            const errorMessages = isArray(message) ? message : [
                message
            ];
            errorMessages.forEach((errorMessage)=>toast.failed(`cart.${errorMessage}`)
            );
        };
        replaceLineItem(draft, onSuccess, handleError, handleError);
    }, [
        bundleSku,
        replaceLineItem
    ]);
    if (isFetching) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    if (!solutions) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(SolutionPicker, {
        activeSolution: activeSolution,
        handleClick: handleClick,
        isLoading: loading,
        solutions: solutions
    });
};

export { ContactLensesBundleBeneluxSolutionsContainer };
//# sourceMappingURL=ContactLensesBundleBeneluxSolutionsContainer.js.map
